import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import UserRole from '@careerstart/wae-common/src/main/constants/user-role';

/**
 * Custom hook to manage dashboard permissions and role-based logic
 * @param {Object} user - The current user object
 * @returns {Object} Dashboard permission states and computed values
 */
const useDashboardPermissions = (user) => {
  const { id } = useParams();

  return useMemo(() => {
    const isAdmin = user?.role === UserRole.ADMIN;
    const isRecruiter = user?.role === UserRole.RECRUITER;
    const isAdminOrRecruiter = isAdmin || isRecruiter;
    const pathSelectedAgencyId = id;
    const recruitersAgencyId = isRecruiter && user?.recruiter?.agency?.ID;
    const isAgencyDashboard = isRecruiter || pathSelectedAgencyId;

    // Permission to view a specific agency:
    // - Admins can view any agency
    // - Recruiters can only view their own agency
    const canViewAgency = isAdmin || (isRecruiter && recruitersAgencyId === id);

    return {
      isAdmin,
      isRecruiter,
      isAdminOrRecruiter,
      pathSelectedAgencyId,
      recruitersAgencyId,
      isAgencyDashboard,
      canViewAgency,
    };
  }, [user?.role, user?.recruiter?.agency?.ID, id]);
};

export default useDashboardPermissions;
